'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var index = require('../../../aviary-core/dist/cjs/index.cjs');

/**
 * SVG Illustration of patient history mobile
 */ const PatientHistoryMobile = ({ assetColor = index.ASSET_COLORS.grey, size = index.ILLUSTRATION_DIMENSIONS.medium, ...rest })=>{
    const theme = react.useTheme();
    return /*#__PURE__*/ jsxRuntime.jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 104 104",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...rest,
        children: [
            /*#__PURE__*/ jsxRuntime.jsx("ellipse", {
                cx: "51.9362",
                cy: "51.998",
                rx: "51.9362",
                ry: "51.998",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "42.9922",
                y: "68.6543",
                width: "17.576",
                height: "5.22681",
                rx: "1.61599",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M40.485 18.4707H62.9533C64.5856 18.4797 66.1482 19.134 67.3008 20.2911C68.4534 21.4481 69.1027 23.0142 69.1072 24.6482V78.5387C69.1027 80.1757 68.451 81.7443 67.2947 82.9019C66.1384 84.0594 64.5715 84.7117 62.9362 84.7162H40.4678C38.8326 84.7117 37.2656 84.0594 36.1093 82.9019C34.953 81.7443 34.3014 80.1757 34.2969 78.5387V66.6855V59.0569V57.1833V24.6482C34.3014 23.0083 34.9554 21.437 36.1154 20.279C37.2754 19.121 38.8468 18.4707 40.485 18.4707Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M58.3371 68.7324H45.1123C43.7041 68.7324 42.5625 69.8752 42.5625 71.2849C42.5625 72.6947 43.7041 73.8375 45.1123 73.8375H58.3371C59.7453 73.8375 60.8869 72.6947 60.8869 71.2849C60.8869 69.8752 59.7453 68.7324 58.3371 68.7324Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "48.793",
                y: "73.8301",
                width: "6.04032",
                height: "5.91312",
                rx: "2.95656",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "36.9883",
                y: "21.4219",
                width: "29.6647",
                height: "48.9176",
                rx: "1.98179",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "42.0234",
                y: "43.418",
                width: "17.7637",
                height: "1.20575",
                rx: "0.602876",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "42.0234",
                y: "52.7559",
                width: "17.7637",
                height: "1.20575",
                rx: "0.602876",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "42.0234",
                y: "46.7285",
                width: "9.93562",
                height: "1.20575",
                rx: "0.602876",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "42.0234",
                y: "56.0781",
                width: "9.93562",
                height: "1.20575",
                rx: "0.602876",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "42.0234",
                y: "50.0449",
                width: "14.1507",
                height: "1.20575",
                rx: "0.602876",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "42.0234",
                y: "59.3867",
                width: "14.1507",
                height: "1.20575",
                rx: "0.602876",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("ellipse", {
                cx: "47.4351",
                cy: "34.3634",
                rx: "5.41943",
                ry: "5.42588",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("mask", {
                id: "mask0_3459_2835",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: "42",
                y: "28",
                width: "11",
                height: "12",
                children: /*#__PURE__*/ jsxRuntime.jsx("ellipse", {
                    cx: "47.4351",
                    cy: "34.3634",
                    rx: "5.41943",
                    ry: "5.42588",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ jsxRuntime.jsxs("g", {
                mask: "url(#mask0_3459_2835)",
                children: [
                    /*#__PURE__*/ jsxRuntime.jsx("path", {
                        d: "M47.4351 35.1505C48.7003 35.1505 49.7329 34.121 49.7329 32.8467C49.7329 31.5724 48.7003 30.5488 47.4351 30.5488C46.1699 30.5488 45.1367 31.5783 45.1367 32.8467C45.1367 34.1152 46.1693 35.1505 47.4351 35.1505Z",
                        fill: theme.ds5.asset[assetColor]["500"]
                    }),
                    /*#__PURE__*/ jsxRuntime.jsx("path", {
                        d: "M43.4453 37.3091C43.3473 37.5922 43.2624 37.8759 43.1953 38.165C44.238 39.3232 45.7444 40.0567 47.4099 40.0567C49.0754 40.0567 50.6031 39.5025 51.6463 38.3443C51.5793 38.0552 51.4719 37.5928 51.3739 37.3091C51.026 36.323 50.2885 35.5649 49.3794 35.1582C48.8183 35.5523 48.1355 35.7808 47.4093 35.7808C46.6831 35.7808 46.0003 35.5529 45.4392 35.1642C44.5242 35.5649 43.7926 36.329 43.4453 37.3091Z",
                        fill: theme.ds5.asset[assetColor]["500"]
                    })
                ]
            })
        ]
    });
};

exports.PatientHistoryMobile = PatientHistoryMobile;
//# sourceMappingURL=PatientHistoryMobile.cjs.map
